<template>
    <span v-if="!isClickable">{{ number }}</span>
    <span v-else>
        <b-link @click="openModal" :class="linkClass">{{ number }}</b-link>

        <b-modal v-model="isModalOpen" :title="`Informatie over product ${number}`" hide-footer>
            <product-info :number="number"
                          :sales-order-line="salesOrderLine"
                          :dispatch-request-line="dispatchRequestLine"
                          :product-name="productName"
                          :show-only-fields="showOnlyFields"
            />
        </b-modal>
    </span>
</template>

<script>
import ProductInfo from "./ProductInfo.vue";

export default {
    name: 'ProductNumber',
    components: {ProductInfo},

    props: {
        number: {required: true, type: String},
        productName: {required: false, type: String},
        linkClass: {required: false, type: String, default: 'text-dark'}, // Class inheritance on non-root elements is not supported in vue2
        dispatchRequestLine: {required: false, type: Object},
        salesOrderLine: {required: false, type: Object},
        showOnlyFields: {required: false, type: Array},
    },

    data() {
        return {
            isModalOpen: false,
        }
    },

    computed: {
        isClickable() {
            return this.hasPermission('products.view')
                && this.$store.getters.getFrontendParameterValue('order-details', 'drq-clickable-product-identifiers');
        },
    },

    methods: {
        openModal() {
            this.isModalOpen = true
        },
    },
}
</script>
